import { CDElement } from "./CDElement";
import { CSSPropertyNameConverter } from "./CSSPropertyNameConverter";
import { RGBColor } from '../colors/RGBColor';
import { HSLColor } from '../colors/HSLColor';
import { HTMLColor } from '../colors/HTMLColor';
import { isClassOf } from '../tools/TypeUtilities';

export class CDProperty extends CDElement
{

  private _rawName:string;
  private _name:string;
  private _value:string;

  constructor( name:string, value:string ) 
  {
    super(CDElement.CDPropertyType);
    this._rawName = name;
    this._name = CSSPropertyNameConverter.convertPropertyName( name );
    this._value = value;
    this.setAttribute("raw-name", name);
    this.setAttribute("name", name);
    this.setAttribute("value", value);
  }

  get isKeyFrameProperty()
  {
    let p = this.parent;
    
    while ( p )
    {
      if ( p.isKeyFrames )
      {
        return true;
      }

      p = p.parent;
    }

    return false;
  }

  get containsVariables() 
  {
    return /var\(\-\-/.test(this.value);
  }

  get containsCalc() 
  {
    return /^calc\(/.test(this.value);
  }
  
  get isStatic() 
  {
    if (this.containsCalc || this.containsVariables) 
    {
      return false;
    }

    return true;
  }

  get rawName() 
  {
    return this._rawName;
  }

  get name() 
  {
    return this._name;
  }

  get value() 
  {
    return this._value;
  }

  static readonly CD_PROPERTY_FLAG_NAME = "CD-PROPERTY-FLAG";

  static isPropertyValue( obj:any ) 
  {
    if ( ! obj )
    {
      return false;
    }

    let type = typeof obj;

    if ( /^(string|bool|number)$/.test( type ) )
    {
      return true;
    }

   
    if ( obj[ this.CD_PROPERTY_FLAG_NAME ] )
    {
      return true;
    }

    if ( "object" !== type )
    {
      return false;
    }

    let classTypes = [ HTMLColor, HSLColor, RGBColor ];
    let belongsToKnownClassType = classTypes.some( c => isClassOf( obj, c ) ); 

    return belongsToKnownClassType;

  }
}